export const T = {
  en_GB: {
    productAssessmentNotConfigured: "Product assessment not configured for this form.",
  },
  nb_NO: {
    productAssessmentNotConfigured: "Produktvurdering er ikke konfigurert for dette skjemaet.",
  },
} as const;
